export default __webpack_public_path__ + "static/media/10.6e05db35.svg";